// OBT F3-D — Bir parkın tüm varlıkları + kronolojik geçmişi (4 sekmeyi besler).
import { useCallback, useEffect, useRef, useState } from 'react';
import { fetchParkAssetHistory } from '../memoryApi';
import { normalizeObtError } from '../../obtErrors';

function isCanceled(error) {
  return (
    error?.code === 'ERR_CANCELED' ||
    error?.name === 'CanceledError' ||
    error?.name === 'AbortError'
  );
}

export function useParkAssetHistory(parkId, { enabled = true } = {}) {
  const [state, setState] = useState({
    loading: Boolean(parkId) && enabled,
    error: null,
    history: null,
  });
  const abortRef = useRef(null);

  const load = useCallback(async () => {
    if (!parkId || !enabled) {
      setState({ loading: false, error: null, history: null });
      return;
    }
    abortRef.current?.abort();
    const controller = new AbortController();
    abortRef.current = controller;
    setState((prev) => ({ ...prev, loading: true, error: null }));
    try {
      const history = await fetchParkAssetHistory(parkId, { signal: controller.signal });
      if (controller.signal.aborted) return;
      setState({ loading: false, error: null, history });
    } catch (error) {
      if (isCanceled(error) || controller.signal.aborted) return;
      setState({ loading: false, error: normalizeObtError(error), history: null });
    }
  }, [parkId, enabled]);

  useEffect(() => {
    load();
    return () => abortRef.current?.abort();
  }, [load]);

  return { ...state, reload: load };
}
